import S from './Recruitment.module.scss';
import RecruitmentCard from '../../common/RecruitmentCard';
import { useSearchParams } from 'react-router-dom';
import SearchCategory from '../../common/SearchCategory';
import { useCallback, useEffect, useState } from 'react';
import {
  RecruitmentContentType,
  RecruitmentFilterResponseType,
  RecruitmentFilterType,
} from '../../../types/RecruitmentTypes';
import { ConstantUtils } from '../../../utils/ConstantUtils';
import {
  fetchRecruitmentFilters,
  fetchRecruitments,
} from '../../../repository/RecruitmentRepository';
import _ from 'lodash';
import {AuthUtils} from "../../../utils/AuthUtils";

const Recruitment = () => {
  const [searchParams] = useSearchParams();
  const queryFilters = searchParams.get('filters');
  const queryKeyword = searchParams.get('keyword');
  const [currentCursor, setCurrentCursor] = useState<string>('');
  const [size, setSize] = useState<number>(12);
  const [recruitments, setRecruitments] = useState<RecruitmentContentType[]>([]);
  const [isLast, setIsLast] = useState<boolean>(false);
  const [filters, setFilters] = useState<RecruitmentFilterResponseType[]>([]);
  const [isFilterFetching, setIsFilterFetching] = useState<boolean>(false);
  const [isRecruitmentFetching, setIsRecruitmentFetching] = useState<boolean>(false);
  const token = AuthUtils.getCookie('token');
  const getRecruitmentFilters = async () => {
    if (isFilterFetching) return;

    setIsFilterFetching(true);

    await fetchRecruitmentFilters()
      .then((res) => {
        if (res) {
          //query string이 있을때는 초기 activate 시켜준다.
          const initialFilter = res.map((filter) => ({
            ...filter,
            isActive: queryFilters?.includes(filter.filter.id) || false,
          }));
          setFilters(initialFilter);
        }
      })
      .catch((e) => console.error(e))
      .finally(() => setIsFilterFetching(false));
  };

  const debouncedHandleScroll = useCallback(
    _.debounce(() => {
      const isBottom =
        window.innerHeight + window.scrollY >= document.documentElement.scrollHeight - 100;

      if (isBottom && !isLast) {
        getRecruitmentList(
          currentCursor,
          makeFilterRequest(queryFilters?.split(',') || []),
          queryKeyword || '',
          true,

        );
      }
    }, 200), // 필요에 따라 디바운스 지연 시간을 조정하세요
    [currentCursor, isLast],
  );

  const getRecruitmentList = async (
    cursor: string,
    filters: RecruitmentFilterType[],
    keyword: string,
    isSearchByScroll: boolean,
  ) => {
    if (isRecruitmentFetching) return;

    setIsRecruitmentFetching(true);

    if (!isSearchByScroll) {
      await fetchRecruitments(keyword, filters, true, cursor, size, token)
        .then((res) => {
          if (res) {
            setRecruitments(res.content);
            setCurrentCursor(res.next);
            if (res.next === null) {
              setIsLast(true);
            } else {
              setIsLast(false);
            }
          }
        })
        .catch((e) => console.error(e))
        .finally(() => setIsRecruitmentFetching(false));
    } else if (isSearchByScroll && !isLast) {
      await fetchRecruitments(keyword, filters, true, cursor, size, token)
        .then((res) => {
          if (res) {
            setRecruitments((prev) => [...prev, ...res.content]);
            setCurrentCursor(res.next);
            if (res.next === null) {
              setIsLast(true);
            } else {
              setIsLast(false);
            }
          }
        })
        .catch((e) => console.error(e))
        .finally(() => setIsRecruitmentFetching(false));
    }
  };

  const makeFilterRequest = (filters: string[]) => {
    const parsedFilters = filters
      .map(ConstantUtils.convertToRecruitmentFilter)
      .filter((filter): filter is RecruitmentFilterType => filter !== undefined && filter !== null);
    return parsedFilters;
  };

  useEffect(() => {
    window.addEventListener('scroll', debouncedHandleScroll);

    return () => {
      window.removeEventListener('scroll', debouncedHandleScroll);
    };
  }, [debouncedHandleScroll]);

  useEffect(() => {
    const filtersArray = queryFilters?.split(',') || [];
    const parsedFilters = makeFilterRequest(filtersArray);
    getRecruitmentList('', parsedFilters, queryKeyword || '', false);
  }, [searchParams]);

  useEffect(() => {
    if (filters.length === 0) {
      getRecruitmentFilters();
    }
  }, []);

  return (
    <>
      <main className={`${S.search_container} wrapper`}>
        <SearchCategory filters={filters} setFilters={setFilters} />
        <section className={S.recruit_post_section}>
          <div className={S.recruit_post_wrap}>
            {recruitments?.map((recruitment, index) => {
              return <RecruitmentCard content={recruitment} key={`recruitment-list-${index}`} />;
            })}
          </div>
        </section>
      </main>
    </>
  );
};

export default Recruitment;
